import { Button } from "@shared/components/ui/button";
import { useGenerateBonDeLivraison } from "@/features/pickups/usePickups";
import { Download, FolderSync } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { getFileUrl } from "@shared/utils/fileUrl";
import { PICKUP_TOAST_KEYS } from "@features/pickups/constants";

const GeneratebonDeLivraison = ({ pickup }) => {
  const { t } = useTranslation("toast");
  const { data, isPending, error, mutate } = useGenerateBonDeLivraison();
  const handleGenerateBonDeLivraison = () => {
    const toastId = toast.loading(t(PICKUP_TOAST_KEYS.GENERATING_BON));
    mutate(pickup._id, {
      onSuccess: () => {
        toast.success(t(PICKUP_TOAST_KEYS.BON_GENERATED), { id: toastId });
      },
      onError: (err) => {
        toast.error(t(PICKUP_TOAST_KEYS.BON_GENERATION_ERROR), { id: toastId });
        console.error("Error generating bon de livraison:", err);
      },
    });
  };
  return (
    <>
      {pickup.bonDeLivraison && (
        <Button variant="ghost" size="icon" disabled={isPending} asChild>
          <Link to={getFileUrl(pickup.bonDeLivraison)} download>
            <Download />
          </Link>
        </Button>
      )}
      <Button
        variant="ghost"
        size="icon"
        onClick={handleGenerateBonDeLivraison}
      >
        <FolderSync />
      </Button>
    </>
  );
};

export default GeneratebonDeLivraison;
